// extracted by mini-css-extract-plugin
export default {"share-guest-banner":"ShareGuestBanner_share-guest-banner__5vX2z","share-guest-banner-container":"ShareGuestBanner_share-guest-banner-container__wJP6W"};